// extracted by mini-css-extract-plugin
module.exports = {"PurchaseTextInput":"PurchaseTextInput_PurchaseTextInput__3gIjb","isSetValue":"PurchaseTextInput_isSetValue__3rXAs"};